export const roadCategoryMap = {
  PM: "Motorway",
  TM: "Motorway",
  PA: "A Road",
  TA: "A Road",
  MB: "B Road",
  MCU: "C/U Road",
};

export const VEHICLE_TYPES = [
  "all_motor_vehicles",
  "cars_and_taxis", // Cars
  "lgvs", // Vans
  "pedal_cycles", // Pedal bikes
  "two_wheeled_motor_vehicles", // Motorbikes
  "all_hgvs", // Lorries
  "buses_and_coaches", // Buses,
] as const;

export type VehicleType = (typeof VEHICLE_TYPES)[number];

export const VEHICLE_TYPES_COLORS = {
  all_motor_vehicles: "#5B5B5B",
  cars_and_taxis: "#599BF5",
  lgvs: "#3BCC90",
  pedal_cycles: "#F09429",
  two_wheeled_motor_vehicles: "#E83F41",
  all_hgvs: "#7F54EF",
  buses_and_coaches: "#E5438E",
};
